<div class="media profile-media">
  <img class="b-r-10" src="assets/images/dashboard/profile.png" alt="" />
  <div class="media-body">
    <span>{{ userName }}</span>
    <p class="mb-0 font-roboto"><i class="middle fa fa-angle-down"></i></p>
  </div>
</div>
<ul class="profile-dropdown onhover-show-div">
  <!-- <li><a href="/user/profile"><app-feather-icons [icon]="'user'"></app-feather-icons><span>Account </span></a></li> -->
  <!-- <li><a href="email"><app-feather-icons [icon]="'mail'"></app-feather-icons><span>Inbox</span></a></li> -->
  <!-- <li><a href="/to-do"><app-feather-icons [icon]="'file-text'"></app-feather-icons><span>Taskboard</span></a></li> -->
  <li>
    <a [routerLink]="'/settings'">
      <app-feather-icons [icon]="'settings'"/>
      <span>Ajustes</span>
    </a>
  </li>
  <li (click)="logoutFunc()">
    <app-feather-icons [icon]="'log-out'"/>
    <span>Logout</span>
  </li>
</ul>
